// export const API_LINK = "http://localhost:3002/";
export const API_LINK = "https://api-dot-ticoop-br.rj.r.appspot.com/";
